import { createContext, useState } from 'react';

type PaymentModalStatusContextType = {
  invoiceIds: string[];
  setInvoiceIds: (invoiceIds: string[]) => void;
};

const PaymentModalStatusContext = createContext<PaymentModalStatusContextType>({
  invoiceIds: [],
  setInvoiceIds: () => {},
});

const PaymentModalStatusProvider = ({ children }: React.PropsWithChildren): JSX.Element => {
  const [invoiceIds, setInvoiceIds] = useState<string[]>([]);

  return (
    <PaymentModalStatusContext.Provider value={{ invoiceIds, setInvoiceIds }}>
      {children}
    </PaymentModalStatusContext.Provider>
  );
};
export default PaymentModalStatusContext;
export { PaymentModalStatusProvider };
